import { render, staticRenderFns } from "./AgeGateCookie.vue?vue&type=template&id=88690ecc&"
import script from "./AgeGateCookie.vue?vue&type=script&lang=js&"
export * from "./AgeGateCookie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports